var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 13,
    viewBox: "0 0 82 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_547_241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.38036 10.0321L12.1976 12.4534L11.1846 7.88257L14.5571 4.80655L10.1222 4.41124L8.38036 0.0998678L6.65087 4.41124L2.20361 4.80655L5.57612 7.88257L4.56313 12.4534L8.38036 10.0321Z",
    fill: "#F8C519"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.852 10.0321L28.6693 12.4534L27.6563 7.88257L31.0288 4.80655L26.5939 4.41124L24.852 0.0998678L23.1226 4.41124L18.6753 4.80655L22.0478 7.88257L21.0348 12.4534L24.852 10.0321Z",
    fill: "#F8C519"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.3242 10.0321L45.1414 12.4534L44.1285 7.88257L47.501 4.80655L43.0661 4.41124L41.3242 0.0998678L39.5947 4.41124L35.1475 4.80655L38.52 7.88257L37.507 12.4534L41.3242 10.0321Z",
    fill: "#F8C519"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M57.7949 10.0321L61.6121 12.4534L60.5992 7.88257L63.9717 4.80655L59.5368 4.41124L57.7949 0.0998678L56.0654 4.41124L51.6182 4.80655L54.9907 7.88257L53.9777 12.4534L57.7949 10.0321Z",
    fill: "#F8C519"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M74.2666 10.0321L78.0838 12.4534L77.0708 7.88257L80.4433 4.80655L76.0084 4.41124L74.2666 0.0998678L72.5371 4.41124L68.0898 4.80655L71.4623 7.88257L70.4494 12.4534L74.2666 10.0321Z",
    fill: "#F8C519"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.3773,
    height: 12.3535,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.134766 12.4534)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2ba1db691319d4b056334c8774d0ce3d.svg";
export { ForwardRef as ReactComponent };